module.exports = new __parcel__URL__("ideas-light.7768688a.svg").toString();